module.exports = __webpack_public_path__ + "img/SMT_25_Ms_Violet_Ng.2697010e.jpg";